<template>
  <el-drawer
    :append-to-body="true"
    :title="eventApprovalTitle"
    :visible.sync="eventApprovalDrawer"
    custom-class="drawerClass"
    direction="ltr"
    size="1000px"
  >
    <div class="warpContent">
      <el-descriptions :colon="false" :column="5" direction="vertical">
        <el-descriptions-item :label="$t('fixDutyFine.eventCategory')">
          <div>{{ rowObj.eventTypeName || '--' }}</div>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('fixDutyFine.abnormalityType')">
          <div>{{ rowObj.exceptionTypeName || '--' }}</div>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('fixDutyFine.abnormalityLevel')">
          <div :style="{ color: rowObj.exceptionLevel === 1 ? 'red' : '' }">
            {{ rowObj.exceptionLevelName || '--' }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('fixDutyFine.estimatedLossAmount')">
          <div>{{ 'R$ ' + rowObj.financeLoss || '--' }}</div>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('fixDutyFine.casualtyCount')">
          <div>{{ rowObj.lossPeopleQuantity || 0 }}</div>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('fixDutyFine.affectedPackageCount')">
          <div>{{ rowObj.waybillQuantity || 0 }}</div>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('fixDutyFine.abnormalityDescription')" :span="4">
          <div>{{ rowObj.exceptionDetail || '--' }}</div>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('fixDutyFine.hasPoliceReceipt')" :span="2">
          <div>{{ rowObj.policeReceiptName || '--' }}</div>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('fixDutyFine.hasMDFE')" :span="2">
          <div>{{ rowObj.mdfeInvoiceName || '--' }}</div>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('fixDutyFine.hasElectronicLock')">
          <div>{{ rowObj.electronicLockName || '--' }}</div>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('fixDutyFine.photos')" :span="5">
          <div v-if="rowObj.photoList" class="demo-image__preview" style="z-index: 9999">
            <el-image
              v-for="(item2, index2) in rowObj.photoList"
              :key="index2"
              :preview-src-list="[item2]"
              :src="item2"
              fit="contain"
              style="width: 100px; margin-right: 5px"
            />
          </div>
          <div v-else>--</div>
        </el-descriptions-item>
        <el-descriptions-item v-if="isEvent" :label="$t('home.appliveResult')" :span="5">
          <div>
            <el-radio-group v-model="approveStatus">
              <el-radio
                :label="1" style="font-weight: bold"
              >{{ $t('customerManagements.approved') }}
              </el-radio>
              <el-radio
                :label="2" style="font-weight: bold"
              >{{ $t('orderCenterCont.ReviewFailed') }}
              </el-radio>
            </el-radio-group>
          </div>
        </el-descriptions-item>
        <el-descriptions-item
          v-if="approveStatus === 1 && isEvent"
          :label="$t('fixDutyFine.excludeFromTimeliness')"
          :span="5"
        >
          <div>
            <el-radio-group v-model="removeAging">
              <el-radio :label="0" style="font-weight: bold">{{ $t('GlobalSetObj.No') }}</el-radio>
              <el-radio :label="1" style="font-weight: bold">{{ $t('GlobalSetObj.yes') }}</el-radio>
            </el-radio-group>
          </div>
        </el-descriptions-item>
      </el-descriptions>
      <div v-if="isEvent" style="text-align: right; margin-top: 20px">
        <el-button @click="eventApprovalDrawer = false">{{ $t('GlobalSetObj.cancel') }}</el-button>
        <el-button type="primary" @click="confirm">{{ $t('trajectory.submit') }}</el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { modifyExceptionApprove } from '@/api/bulkExpressApi';

export default {
  data() {
    return {
      eventApprovalDrawer: false,
      removeAging: 2, // 是否剔除时效  0否  1是
      approveStatus: 0, // 审批状态   0-待审批,1-审批通过,2-审批不通过
      rowObj: {},
      isEvent: true,
      eventApprovalTitle: this.$t('fixDutyFine.eventApproval')
    };
  },
  methods: {
    showApprovalDrawer(arg, type) {
      console.log(arg);
      if (type === 2) {
        this.isEvent = false;
        this.eventApprovalTitle = this.$t('fixDutyFine.viewDetails');
      } else {
        this.isEvent = true;
        this.approveStatus = 0;
        this.removeAging = 2;
        this.eventApprovalTitle = this.$t('fixDutyFine.eventApproval');
      }
      this.eventApprovalDrawer = true;
      this.rowObj = arg;
    },
    confirm() {
      const data = {
        id: this.rowObj.id,
        approveStatus: this.approveStatus
      };
      if (this.approveStatus === 0) {
        this.$message.error(this.$t('changepwd.selectResult'));
        return;
      }
      if (this.approveStatus === 1) {
        if (this.removeAging === 2) {
          this.$message.error(this.$t('fixDutyFine.selectExcludeTimeliness'));
          return;
        } else {
          data.removeAging = this.removeAging;
        }
      }
      modifyExceptionApprove(data).then((res) => {
        if (res.code === 200) {
          this.eventApprovalDrawer = false;
          this.$emit('search');
          this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
        }
      });
    }
  }
};
</script>

<style scoped>
.warpContent {
  height: calc(100vh - 100px);
  overflow: auto;
  padding: 0 20px;
}

.el-descriptions-item__cell div {
  font-weight: bold;
  font-size: 18px;
}

>>> .el-descriptions-item__label {
  font-size: 16px;
  color: #909399;
}

>>> .el-descriptions-item__cell {
  /*height: 35px !important;*/
  padding-bottom: 5px !important;
}
</style>
